var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"withdraw-tab"},[_c('Redeem',{attrs:{"currencies":_vm.currencies}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }